// ------------------------------------
// PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-var';
    const ref2 = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('#footer');

    // Altera o tipo de fundo
    function changeBgType() {
      const value = confTheme[ref2]['bg-type'];
      if (value == 'image') {
        changeBgImage();
      } else if (value == 'gradient') {
        changeBgGradient();
      } else if (value == 'color') {
        changeBgColor();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

    // Altera a imagem de fundo
    function changeBgImage() {
      const image = confTheme[ref2]['bg-image'];
      $section.css('background-image', 'url(' + image + ')');
    }
    $root.on(refEvtPrefix + 'bg-image', changeBgImage);

    // Altera o gradiente de fundo
    function changeBgGradient() {
      const value = confTheme[ref2]['bg-gradient'];
      $section.css('background-image', value);
    }
    $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['footer-bg-color'];
      $section.css('background-image', 'none');
      $section[0].style.setProperty('--footer-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);
  }
})();

// ------------------------------------
// CORES E TEXTO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-var';
    const ref2 = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('#footer');
    const $secText = $('.footer-copyright .md-text');

    // Altera a cor do título
    function changeTitColor() {
      const color = confTheme[ref]['footer-tit-color'];
      $section[0].style.setProperty('--footer-tit-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref2]['texto'];
      $secText.html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'texto', changeText);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['footer-txt-color'];
      $section[0].style.setProperty('--footer-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);
  }
})();

// ------------------------------------
// ATENDIMENTO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-var';
    const ref2 = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('#footer');
    const $element = $('#footer-atendimento');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['atendimento-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'atendimento-show', changeElShow);

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['atendimento-titulo'];
      $element.find('.footer-title').html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'atendimento-titulo', changeTitle);

    // Altera o e-amil
    function changeMail() {
      const value = confTheme[ref2]['email'];
      const $email = $element.find('.footer-email');
      if (!value) {
        $email.parent('li').addClass('d-none');
      } else {
        $email.parent('li').removeClass('d-none');
        $email.attr('href', 'mailto:' + value);
        $email.html(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"/></svg>' +
            value,
        );
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'email', changeMail);

    // Altera o telefone
    function changeTel() {
      const value = confTheme[ref2]['telefone'];
      const $telefone = $element.find('.footer-tel');
      if (!value) {
        $telefone.parent('li').addClass('d-none');
      } else {
        $telefone.parent('li').removeClass('d-none');
        $telefone.attr('href', 'tel:' + somenteNumeros(value));
        $telefone.html(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"/></svg>' +
            value,
        );
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'telefone', changeTel);

    // Altera o whatsapp
    function changeWhats() {
      const whats = confTheme[ref2]['whatsapp'];
      const whatsN = somenteNumeros(whats);
      const whatsMsg = confTheme[ref2]['whatsapp-msg'];
      const linkDesktop = `https://web.whatsapp.com/send?phone=55${whatsN}&text=${whatsMsg}`;
      const linkMobile = `https://web.whatsapp.com/send?phone=55${whatsN}&text=${whatsMsg}`;
      const $whatsLinkDesk = $('.whats-link-desktop');
      const $whatsLinkMob = $('.whats-link-mobile');
      const $whatsText = $('.footer-whats-text');
      if (!whats) {
        $whatsLinkDesk.parent('li').addClass('d-none');
      } else {
        $whatsLinkDesk.parent('li').removeClass('d-none');
        $whatsLinkDesk.attr('href', linkDesktop);
        $whatsLinkMob.attr('href', linkMobile);
        $whatsText.html(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>' +
            whats,
        );
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'whatsapp', changeWhats);
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'whatsapp-msg', changeWhats);

    // Oculta/Exibe whatsapp lateral
    function changeWhatsLat() {
      const value = confTheme[ref2]['whatsapp-lateral'];
      const $whatsLat = $('.contatos-lateral');
      value == '1' ? $whatsLat.removeClass('d-none') : $whatsLat.addClass('d-none');
      handleWhatsLatPos();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'whatsapp-lateral', changeWhatsLat);

    // Posição do whatsapp lateral
    function changeWhatsLatPos() {
      const value = confTheme[ref2]['whatsapp-lateral-pos'];
      const $whatsLat = $('.contatos-lateral');
      $whatsLat.removeClass('middle-right middle-left bottom-right bottom-left').addClass(value);
      handleWhatsLatPos();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'whatsapp-lateral-pos', changeWhatsLatPos);
  }
})();

// ------------------------------------
// FORMAS DE PAGAMENTO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-var';
    const ref2 = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $element = $('#footer-pagamentos');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['pagamentos-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'pagamentos-show', changeElShow);
  }
})();

// ------------------------------------
// CERTIFICADOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-var';
    const ref2 = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('#footer');
    const $element = $('.footer-certificados');
    const $image = $('.footer-certificados-img');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['certificados-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'certificados-show', changeElShow);

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['certificados-titulo'];
      $element.find('.footer-title').html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'certificados-titulo', changeTitle);

    // Altera a imagem
    function changeImage() {
      const image = confTheme[ref2]['certificados-src'];
      $image.find('img').attr('src', image);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'certificados-src', changeImage);

    // Altera o texto alternativo da imagem
    function changeImageAlt() {
      const value = confTheme[ref2]['certificados-alt'];
      $image.find('img').attr('alt', value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'certificados-alt', changeImageAlt);
  }
})();

// ------------------------------------
// REDES SOCIAIS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-var';
    const ref2 = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('#footer');
    const $element = $('#footer-redes');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['redes-sociais-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-show', changeElShow);

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['redes-sociais-titulo'];
      $element.find('.footer-title').html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-titulo', changeTitle);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['redes-sociais-bg-color'];
      $section[0].style.setProperty('--redes-sociais-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-bg-color', changeBgColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['redes-sociais-txt-color'];
      $section[0].style.setProperty('--redes-sociais-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-txt-color', changeTxtColor);
  }
})();

// ------------------------------------
// REDES SOCIAIS (LISTA)
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-var';
    const ref2 = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Lista de SVG's
    const socialIconsSVG = {
      'fab fa-facebook-f':
        '<svg class="facebook" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/></svg>',
      'fab fa-instagram':
        '<svg class="instagram" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>',
      'fab fa-twitter':
        '<svg class="twitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg>',
      'fab fa-linkedin-in':
        '<svg class="linkedin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/></svg>',
      'fab fa-youtube':
        '<svg class="youtube" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"/></svg>',
      'fab fa-whatsapp':
        '<svg class="whatsapp" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>',
      'fab fa-telegram-plane':
        '<svg class="telegram" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"/></svg>',
      'fab fa-tiktok':
        '<svg class="tiktok" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"/></svg>',
    };

    // Elementos
    const $list = $('#redes-sociais');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['redes-sociais'];
      if ($list.length > 0) {
        $list.html('');
        for (let i = 0; i < lista.length; i++) {
          if (lista[i].url != '' && lista[i].status == '1') {
            const item = `
            <a href="${lista[i].url}" rel="nofollow" target="_blank" class="social-icon si-circle" title="${
              lista[i].titulo
            }">
              ${socialIconsSVG[lista[i].icon]}
            </a>`;
            $list.append(item);
          }
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-lista', changeList);
  }
})();

// ------------------------------------
// SELOS ADICIONAIS (LISTA)
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-var';
    const ref2 = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $list = $('#footer-selos');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['selos'];
      if ($list.length > 0) {
        $list.html('');
        for (let i = 0; i < lista.length; i++) {
          const item = `
          <a href="${lista[i].url}" target="_blank" class="grid-2 grid-sm-4 grid-xs-6 footer-selos-item">
            <img src="${lista[i].img}" alt="${lista[i].alt}">
          </a>`;
          $list.append(item);
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'selos', changeList);
  }
})();

// ------------------------------------
// LINKS FOOTER
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer-variables';
    const ref2 = 'footer';

    // Elementos
    const $menuLista = $('#footer-links-list');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['footer-links'];
      if ($menuLista.length > 0) {
        $menuLista.html('');
        for (let i = 0; i < lista.length; i++) {
          const menuDataInst = lista[i].tipo_link == 'institucional' ? 'data-modal-pag="' + lista[i].url + '"' : '';
          const item = `<li><a href="${lista[i].url}" ${menuDataInst}>${lista[i].titulo}</a></li>`;
          $menuLista.append(item);
        }
      }
    }
    $root.on(confEvtDefault + ' lp-evt-footer-links-lista', changeList);
  }
})();
